import React, { useEffect, useMemo, useState } from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import EventList from './Event/EventList';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTripEvents } from '../../store/actions/events';
import { selectFirstReceipt } from '../../store/selectors/mytrips.selector';
import { selectGroupedEvents } from '../../store/selectors/events.selector';
import EventSelector from './Event/EventSelector';
import moment from 'moment';

const Event = ({ userType }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('Event');
  const dispatch = useDispatch();
  const [selectedDay, setSelectedDay] = useState('all');
  const receiptResponse = useSelector(selectFirstReceipt);
  const groupedEvents = useSelector(
    selectGroupedEvents(
      receiptResponse.FromDate,
      moment(receiptResponse.ToDate)
        .set('hour', 23)
        .set(('minutes', 59))
        .toDate()
    )
  );

  const selectedDays = useMemo(
    () => [
      { label: t(tKey('AllDays')), id: 'all' },
      ...(groupedEvents
        ? Object.keys(groupedEvents).map((date) => ({ label: date, id: date }))
        : []),
    ],
    [groupedEvents, t, tKey]
  );
  const filteredData = useMemo(() => {
    if (groupedEvents && selectedDay) {
      if (selectedDay === 'all') {
        return groupedEvents;
      } else {
        return {
          [selectedDay]: groupedEvents[selectedDay],
        };
      }
    }
  }, [groupedEvents, selectedDay]);

  const onChangeSelection = (day) => {
    setSelectedDay(day.id);
  };

  useEffect(() => {
    dispatch(fetchTripEvents(receiptResponse.TripId));
  }, [receiptResponse.TripId, dispatch]);

  return (
    <ScrollView style={styles.container}>
      <BaseText style={styles.title}>{t(tKey('EventSchedule'))}</BaseText>
      <EventSelector
        style={CommonStyles.my5}
        days={selectedDays}
        selected={selectedDay}
        onChange={onChangeSelection}
      />
      <EventList userType={userType} events={filteredData} />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.accent,
    ...CommonProperties.p3,
  },
  title: {
    ...CommonProperties.h2,
    ...CommonProperties.mt3,
  },
});

export default Event;
